import { forwardRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeSlash } from "@phosphor-icons/react";

/** Password input with an accessible show/hide toggle. Visibility state is local to each instance. */
export const PasswordInput = forwardRef(function PasswordInput({ className = "", "data-testid": testid, ...props }, ref) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input ref={ref} {...props} type={show ? "text" : "password"} data-testid={testid}
        className={`pr-11 ${className}`} autoComplete={props.autoComplete || (props.name === "new" ? "new-password" : "current-password")} />
      <button type="button" onClick={() => setShow((s) => !s)} aria-label={show ? "Hide password" : "Show password"} aria-pressed={show}
        title={show ? "Hide password" : "Show password"} tabIndex={0} disabled={props.disabled}
        data-testid={testid ? `${testid}-toggle` : undefined}
        className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 flex items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-40">
        {show ? <EyeSlash size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
});
